
import {VIEW_TYPE} from '../../../../enums/ViewType';
import DeleteModal from '../../../Modals/DeleteModal';
import DishesApp from './Functionality/DishesApp';
import DishesCards from './SubComponents/DishesCards';
import DishesTable from './SubComponents/DishesTable';

/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */
const Dishes = ({ setBodyForExport, modified, setModified, option}) => {
    const {
        t,
        deleteModalShow,
        handleDeleteSelected,
        handleDeleteModalClose,
        selectedList,
        setSelectedList,
        isAllChecked,
        setIsAllChecked,
        view,
        setView,
    } = DishesApp({
        setModified
    });

    return (
        <>
            {view === VIEW_TYPE.GRID.name && (
                <>
                    <DishesCards
                        view={view}
                        setView={setView}
                        setBodyForExport={setBodyForExport}
                        modified={modified}
                        setModified={setModified}
                        selectedList={selectedList}
                        setSelectedList={setSelectedList}
                        isAllChecked={isAllChecked}
                        setIsAllChecked={setIsAllChecked}
                        option={option}
                    />
                </>
            )}

            {view === VIEW_TYPE.LIST.name && (
                <>
                    <DishesTable
                        view={view}
                        setView={setView}
                        setBodyForExport={setBodyForExport}
                        modified={modified}
                        setModified={setModified}
                        selectedList={selectedList}
                        setSelectedList={setSelectedList}
                        isAllChecked={isAllChecked}
                        setIsAllChecked={setIsAllChecked}
                        option={option}
                    />
                </>
            )}

            {deleteModalShow && (
                <DeleteModal
                    show={deleteModalShow}
                    onHide={() => handleDeleteModalClose()}
                    onClickFn={() => {
                        handleDeleteSelected();
                    }}
                    data={selectedList}
                    title_modal={t('delete_meals')}
                    element_modal={t('meals')}
                />
            )}
        </>
    );
};

export default Dishes;
